import styles from './DisputeSortFilter.module.scss';
import { DisputeSortOptions } from 'state';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';

type SortOption = (typeof DisputeSortOptions)[number];

type Props = {
    disputeSort: SortOption | undefined,
    onDisputeSortChange: (value: SortOption) => void
};

const DisputeSortFilter = ({ disputeSort, onDisputeSortChange }: Props) => (
    <DropDownButton 
        className={styles.control}
        items={DisputeSortOptions}
        onItemClick={(e) => onDisputeSortChange(e.item as SortOption)}
        tabIndex={0}
        text={<span className={styles.text}>{disputeSort?.text}</span>}
    />
);
export default DisputeSortFilter;
